import CloseOutlinedIcon from '@ant-design/icons/CloseOutlined'

import Stack from '@mui/material/Stack'
import { alpha } from '@mui/material/styles'
import IconButton from '@components/_mui/IconButton'
import Typography from '@components/_mui/Typography'

export const styles = {
  container: (theme) => ({
    minWidth: 300,
    maxWidth: 400,
    width: '100%',
    p: 1,

    backdropFilter: `blur(${theme.spacing(1)})`,
    WebkitBackdropFilter: `blur(${theme.spacing(1)})`,

    backgroundColor: alpha(theme.palette.primary.main, 0.6),

    color: 'primary.contrastText',
    borderRadius: 2,
    boxShadow: theme.customShadows.z2,
  }),
  warning: (theme) => ({
    backgroundColor: alpha(theme.palette.warning.main, 0.7),
  }),
  close: {
    top: -4,
    right: -4,
    color: 'primary.contrastText',
    position: 'absolute',
  },
}

export function Title({ color, label, onClose }) {
  return (
    <Stack direction="row" sx={{ pr: 3, position: 'relative' }}>
      <Typography variant="h5">{label}</Typography>
      <IconButton
        size="small"
        color={color}
        shape="rounded"
        component="div"
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          onClose?.()
        }}
        sx={styles.close}
      >
        <CloseOutlinedIcon style={{ fontSize: 16 }} />
      </IconButton>
    </Stack>
  )
}
